import { styled } from '@mui/material/styles';
import { Box, TableRow } from '@mui/material';

// Figma "Drop shadow/Medium" (FTDS modals). Figma's blur maps 1:1 to the box-shadow blur radius.
export const FTDS_MODAL_SHADOW = '4px 4px 24px 0px rgba(0, 8, 31, 0.12), 0px 4px 2px 0px rgba(0, 8, 31, 0.04)';

interface StyledValidationTableRowProps {
    $isInvalid?: boolean;
}

export const StyledValidationTableRow = styled(TableRow, {
    shouldForwardProp: (prop) => prop !== '$isInvalid'
})<StyledValidationTableRowProps>(({ theme, $isInvalid }) => ({
    ...($isInvalid && {
        '&.MuiTableRow-root': {
            boxShadow: `inset 0 0 0 2px ${theme.palette.error[500]}`
        }
    })
}));

export const InfoMessage = styled('div')(({ theme }) => ({
    display: 'flex',
    width: '100%',
    height: '64px',
    padding: '16px 40px 16px 16px',
    alignItems: 'center',
    gap: '16px',
    alignSelf: 'stretch',
    borderRadius: '6px',
    border: `1px solid ${theme.palette.berry[400]}`,
    background: theme.palette.berry[100],
    '& span': {
        color: theme.palette.neutral.black,
        fontFamily: '"TT Commons Pro"',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '20px'
    }
}));

export const GoalTypeIcon = styled('div')<{ color?: string; backgroundColor?: string }>(
    ({ theme, color, backgroundColor }) => ({
        display: 'flex',
        width: '104px',
        height: '104px',
        padding: '24px',
        borderRadius: '6px',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: backgroundColor || theme.palette.neutral.white,
        gap: '10px',
        '& svg': {
            width: '64px',
            height: '64px',
            color
        }
    })
);

export const GoalTypeIconSmall = styled('div')<{ color?: string; backgroundColor?: string }>(
    ({ theme, color, backgroundColor }) => ({
        display: 'flex',
        width: '40px',
        height: '40px',
        padding: '8px',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: backgroundColor || theme.palette.neutral.white,
        gap: '10px',
        '& svg': {
            width: '40px',
            height: '40px',
            color
        }
    })
);

export const ContainerBox = styled(Box)(() => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
}));

export const ContentContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isTabIncluded'
})<{ isTabIncluded?: boolean }>(({ theme, isTabIncluded = true }) => ({
    width: '100%',
    backgroundColor: theme.palette.neutral.white,
    border: `1px solid ${theme.palette.grey[100]}`,
    borderTop: isTabIncluded ? 'none' : `1px solid ${theme.palette.grey[100]}`,
    borderRadius: isTabIncluded ? '0 0 16px 0' : '16px',
    padding: '24px'
}));
